import Delegate from "//legramme.com/cdn/shop/t/76/assets/ftdomdelegate.min.js?v=167457923630348017651764174054";

export class HomeSliderSection extends HTMLElement {
    connectedCallback() {
      this.videoMobile      = this.querySelector('#hero-section__video--mobile');
      this.videoDesktop     = this.querySelector('#hero-section__video--desktop');
      this.buttonOn         = this.querySelector('.hero-section__actions-sound-on');
      this.buttonOff        = this.querySelector('.hero-section__actions-sound-off');
      this.mediaQuery       = '(min-width: 1024px)';
      this.mediaQueryList   = window.matchMedia(this.mediaQuery);
  
      let that = this;
      Pace.on('done', function() {
        that._initVideo();
        that._attachListeners();
        that._initParallax();
      });
  
  
      // Responsive mute
      //window.addEventListener('resize', Debounce.debounceKeyPress(this._videoResponsive, 500));
      if (this.videoDesktop && this.videoMobile) {
        window.addEventListener('scroll', that._throttle(that._pauseVideoOnHide.bind(this), 1000));
      }
  
    }
  
    _attachListeners() {
       new Delegate(this).on('click', '[data-vimeo="unmute"]', this._activeSound.bind(this));
       new Delegate(this).on('click', '[data-vimeo="mute"]', this._muteSound.bind(this));
    }
  
    _initVideo() {
      if (this.mediaQueryList.matches) {
        if (this.videoDesktop) {
          this.buttonOn.setAttribute('data-device', 'desktop');
          this.buttonOff.setAttribute('data-device', 'desktop');
          this.videoDesktop.setAttribute('src', this.videoDesktop.getAttribute('data-src'));
          this.playerDesktop = new Vimeo.Player($(this.videoDesktop)[0]);
        }
      } else {
        if (this.videoMobile) {
          this.buttonOn.setAttribute('data-device', 'mobile');
          this.buttonOff.setAttribute('data-device', 'mobile');
          this.videoMobile.setAttribute('src', this.videoMobile.getAttribute('data-src'));
          this.playerMobile = new Vimeo.Player($(this.videoMobile)[0]);
        }
      };
    }
  
    _activeSound(event, target) {
      event.preventDefault();
      let device = target.getAttribute('data-device');
      this._soundVideoManager(device, false);
  
      // Buttons
      this.buttonOn.classList.add('hide');
      this.buttonOff.classList.remove('hide');
    }
  
    _muteSound(event, target) {
      event.preventDefault();
      let device = target.getAttribute('data-device');
      this._soundVideoManager(device, true);
  
      /* Buttons */
      this.buttonOn.classList.remove('hide');
      this.buttonOff.classList.add('hide');
    }
  
    _soundVideoManager(device, mute) {
      if (device === 'desktop') {
        if (this.playerDesktop) {
            this.playerDesktop.setMuted(mute);
          } else {
            this.playerDesktop.setMuted(!mute);
          }
      } else if (device === 'mobile') {
        if (this.playerMobile) {
            this.playerMobile.setMuted(mute);
          } else {
            this.playerMobile.setMuted(!mute);
          }
      }
    }
  
    _pauseVideoManager(device, pause) {
      if (device === 'desktop') {
        if (pause) {
          this.playerDesktop.pause();
        } else {
          this.playerDesktop.play();
        }
      } else if (device === 'mobile') {
        if (pause) {
          this.playerMobile.pause();
        } else {
          this.playerMobile.play();
        }
      }
    }
  
    _pauseVideoOnHide() {
      let videoContainer = document.querySelector('.shopify-section-hero');
      if (videoContainer) {
        if (videoContainer.getBoundingClientRect().top + videoContainer.offsetHeight < 0) {
          if (this.mediaQueryList.matches) {
            this._pauseVideoManager('desktop', true)
          } else {
            this._pauseVideoManager('mobile', true)
          }
        } else {
          if (this.mediaQueryList.matches) {
            this._pauseVideoManager('desktop', false)
          } else {
            this._pauseVideoManager('mobile', false)
          }
        }
      }
  
    }
  
    _initParallax() {
      let rellax = new Rellax('.hero-section__image-container', {
        speed: -4
      });
    }
  
    _throttle(fn, wait) {
      let time = Date.now();
      return function() {
        if ((time + wait - Date.now()) < 0) {
          fn();
          time = Date.now();
        }
      }
    }
}
try {
  window.customElements.define('slide-section', HomeSliderSection);
} catch(e) {}